import React, { useState } from 'react';
import { planningTabsStyle as styles } from '../../css/styles/componentStyles';

const PlanningTabs = ({activeBuisnessTab,setActiveBuisnessTab}) => {
  const planningTabs = [
    {title: "Business", icon: "📊"},
    {title: "CashFlow", icon: "💰"},
  ];
  

 

  const handleTabClick = (title) => {
    setActiveBuisnessTab(title);
  };

  return (
    <div style={styles.container}>
      <div style={styles.tabsWrapper}>
        <div style={styles.backgroundGlow}></div>
        <div style={styles.tabsContainer}>
          {planningTabs.map((item, index) => {
            const isActive = activeBuisnessTab === item.title;
            return (
              <div
                key={index}
                style={{
                  ...styles.tab,
                  ...(isActive ? styles.tabActive : styles.tabInactive)
                }}
                onClick={() => handleTabClick(item.title)}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                    e.target.style.transform = "translateY(-1px)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.transform = "translateY(0px)";
                  }
                }}
              >
                <div style={styles.tabContent}>
                  <span 
                    style={{
                      ...styles.tabIcon,
                      transform: isActive ? "scale(1.1)" : "scale(1)"
                    }}
                  >
                    {item.icon}
                  </span>
                  <span style={styles.tabText}>
                    {item.title}
                  </span>
                </div>
                <div 
                  style={{
                    ...styles.shimmer,
                    left: isActive ? "100%" : "-100%"
                  }}
                ></div>
              </div>
            );
          })}
        </div>
      </div>
      
    
    </div>
  );
};

export default PlanningTabs;